import { render, staticRenderFns } from "./StaticFullEventsCalendar.vue?vue&type=template&id=00059bcd&scoped=true&"
import script from "./StaticFullEventsCalendar.vue?vue&type=script&lang=js&"
export * from "./StaticFullEventsCalendar.vue?vue&type=script&lang=js&"
import style0 from "./StaticFullEventsCalendar.vue?vue&type=style&index=0&id=00059bcd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00059bcd",
  null
  
)

export default component.exports